<template>
  <div>
    <div class="mt-5 d-flex justify-space-between heading-1">Order Detail</div>
    <v-row class="mt-3">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"> Order No:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >#{{ orderDetails && orderDetails?.OrderCode }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Email Address:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2"> {{ orderDetails && orderDetails?.Items[0]?.UserEmail }} </span></div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Placed Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >{{ formatDate(this.orderDetails?.Items[0]?.OrderDate) }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <!-- v-if="this.orderDetails?.Items[0].OrderType !== 1" -->
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Received Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">{{
            formatDate(this.orderDetails?.Items[0]?.Shipping?.ReceivedDate)
          }}</span>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"> Product Service Name:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <router-link to="" class="mt-2 text-decoration-underline"
            >Seminar Payement for Finding Health consolidated- LIVESTREAM in FL
            starting 04 March
          </router-link>
        </div>
      </v-col>
    </v-row> -->
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Course Status: </span>
      </v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2"
          >Finding Health consolidated- LIVESTREAM
        </span>
      </v-col>
    </v-row> -->
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Status:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            <v-card max-width="150" flat>
              <v-select
                class="my-0 py-0"
                v-model="selectedStatus"
                :items="orderStatusItems"
                item-value="Status"
                item-text="state"
                label="Select"
                persistent-hint
                return-object
                single-line
                @change="setNewOrderStatus"
              ></v-select>
            </v-card>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Ship Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >{{ formatDate(this.orderDetails?.Items[0]?.Shipping?.ShippedDate) }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0" >
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Ship Method:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.ShippingMethod }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping Note:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div class="">
          <span class="style_txt_hh2 mb-2">
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.ShippingNote }}
          </span>
          <!-- <v-text-field
            v-if="IsEditing"
            single-line
            dense
            v-model="orderDetails.Items[0].Shipping.ShippingNote"
          ></v-text-field>
          <v-btn
            rounded
            outlined
            v-if="!IsEditing"
            color="#1884CD"
            class="px-9"
            dark
            style="text-transform: none !important; border: 1px solid #d2e5fc"
            @click="IsEditing = true"
            >Edit
          </v-btn>
          <v-btn
            rounded
            outlined
            v-if="IsEditing"
            color="green"
            class="px-9"
            dark
            style="
              text-transform: none !important;

              border: 1px solid #d2e5fc;
            "
            @click="Update(orderDetails?.Items[0]?.Shipping?.ShippingNote,orderDetails?.Items[0]?.Shipping?.Id)"
            >Update
          </v-btn>
          <v-btn
            rounded
            outlined
            v-if="IsEditing"
            color="red"
            class="px-9 ml-3"
            dark
            style="
              text-transform: none !important;

              border: 1px solid red;
            "
            @click="IsEditing = false"
            >Cancel
          </v-btn> -->

          <!-- Above code is needed if want to edit shipping note -->

          <!-- {{ notes }}
          <v-edit-dialog :return-value.sync="notes">
            {{ notes }}
            <template v-slot:input>
              <v-text-field v-model="notes" label="Edit" single-line counter />
            </template>
            <v-btn
              color="primary"
              depressed
              class="text_trans"
              outlined
              rounded
              @click="updateNotes"
            >
              Update
            </v-btn>
          </v-edit-dialog> -->
        </div>
        
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Admin Note:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div class="d-flex gap-4 align-center">
          <span class="style_txt_hh2 mb-2" v-if="!IsEditing">
            {{ orderDetails && orderDetails?.Items[0]?.AdminNote }}
          </span>
          <v-text-field
            v-if="IsEditing"
            single-line
            dense
            v-model="orderDetails.Items[0].AdminNote"
          ></v-text-field>
          <v-btn
            rounded
            outlined
            v-if="!IsEditing"
            color="#1884CD"
            class="px-9"
            dark
            style="text-transform: none !important; border: 1px solid #d2e5fc"
            @click="IsEditing = true"
            >Edit
          </v-btn>
          <v-btn
            rounded
            outlined
            v-if="IsEditing"
            color="green"
            class="px-9"
            dark
            style="
              text-transform: none !important;

              border: 1px solid #d2e5fc;
            "
            @click="Update(orderDetails?.Items[0]?.AdminNote,orderDetails?.Items[0]?.OrderCode)"
            >Update
          </v-btn>
          <v-btn
            rounded
            outlined
            v-if="IsEditing"
            color="red"
            class="px-9"
            dark
            style="
              text-transform: none !important;

              border: 1px solid red;
            "
            @click="IsEditing = false"
            >Cancel
          </v-btn>

        </div>

      </v-col>
    </v-row>

    <v-row class="my-5">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Billing Address:</span>
        <div class="mt-3">
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.FirstName }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.LastName }} <br />
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.StreetAddress1 }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.StreetAddress2 }}
            <br />
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.City }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.ZipCode }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.Province }} <br />
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.Country }}</span
          >
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping Address :</span>
        <div class="mt-3">
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.FirstName }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.LastName }} <br />
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.StreetAddress1 }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.StreetAddress2 }}
            <br />
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.City }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.ZipCode }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.Province }} <br />
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.Country }}</span
          >
        </div>
      </v-col>
    </v-row>

    <div><span class="style_txt_hh2 primary--text mt-4">Product Details </span></div>
    <div class="my-5">
      <v-row>
        <v-col cols="12" md="10">
          <table style="width: 100%; border-collapse: collapse">
            <tr style="border: 1px solid">
              <th style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center py-2">Product Type</div>
              </th>
              <th style="border: 1px solid; width: 30%">
                <div class="d-flex justify-center py-2">Name</div>
              </th>
              <th style="border: 1px solid; width: 10%">
                <div class="d-flex justify-center py-2 text-center">
                  {{orderDetails?.Items[0]?.OrderType == 3 ? "Full Price" : "Unit Price"}}
                 
                </div>
              </th>
              <th style="border: 1px solid; width: 10%">
                <div class="d-flex justify-center text-center py-2">
                  {{orderDetails?.Items[0]?.OrderType == 3 ? "Early Bird Price" : "Quantity"}}
                </div>
              </th>
              <th style="border: 1px solid; width: 20%" v-if="orderDetails?.Items[0]?.OrderType == 3 && orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !== 0">
                <div class="d-flex justify-center text-center py-2">
                  Monitor Rate Discount
                </div>
              </th>
              <th style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center py-2">Subtotal</div>
              </th>
            </tr>
            <tr
              v-for="(item, index) in orderDetails && orderDetails?.Items"
              :key="index"
              style="border: 1px solid"
            >
              <td style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center pa-2">
                  <span v-if="item.OrderType == 1">Membership</span>
                  <span v-else-if="item.OrderType == 3">Seminar</span>
                  <span v-else-if="item.OrderType == 5">Exam</span>
                  <span v-else>{{ getProductCategoryLabel(item?.Product?.CategoryId) }}</span>
                </div>
              </td>
              <td style="border: 1px solid; width: 30%">
                <div class="d-flex justify-center align-center pa-2 text-center">
                  
                  <div v-if="item.OrderType == 1">
                    <span v-if="item.MemberShipDetail?.MembershipID === 1">Starter</span>
                    <span v-else-if="item.MemberShipDetail?.MembershipID === 2">Access</span>
                    <span v-else-if="item.MemberShipDetail?.MembershipID === 3">Standard</span>
                    <span v-else-if="item.MemberShipDetail?.MembershipID === 4">Practitioner</span>
                    <span v-else-if="item.MemberShipDetail?.MembershipID === 5">Instructor</span>
                    <span v-else-if="item.MemberShipDetail?.MembershipID === 10">Senior Instructor</span>
                  </div>
                  <div v-else-if="item.OrderType == 3">
                    <span>{{item.SeminarDetail?.Course}}</span>
                    <div v-if="item.SeminarDetail?.SeminarDateAndTime?.length > 1" >
                      ({{
                        extractMonthAndDate(item.SeminarDetail?.SeminarDateAndTime[0].Date)
                      }} to {{
                        extractMonthAndDate(item.SeminarDetail?.SeminarDateAndTime[1]?.Date) }})
                    </div>
                      <div v-else >
                        ({{
                          extractMonthAndDate(item.SeminarDetail?.SeminarDateAndTime[0].Date)
                        }})</div>
                  </div>
                  <div v-else-if="item.OrderType == 5">
                    <span>{{getExamCredentialsLabel(item.ExamDetail?.ExamCredentials)}}</span>
                  </div>
                  <span v-else>{{ item.Product?.ProductName }}</span>
                </div>
              </td>
              <td style="border: 1px solid; width: 10%">
                <div class="d-flex justify-center pa-2">
                  <span v-if="item.OrderType == 5">
                    {{ item.ExamDetail?.PaidAmount }}
                  </span>
                  <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
                      {{ orderDetails?.Items[0]?.SeminarDetail?.FullPrice }}
                  </span>
                  <span v-else-if="item.OrderType == 1">
                    {{ membershipPrice }}
                  </span>
                  <span v-else>
                    <span v-if="item?.Product?.CategoryId === 26">
                      {{ (item?.Payment?.Price / item?.Quantity)?.toFixed(2) }}
                    </span>
                    <span v-else>
                      {{ item?.Amount }}
                    </span>
                  </span>
                </div>
              </td>
              <td style="border: 1px solid; width: 10%">
                <div class="d-flex justify-center pa-2">
                  {{ item.OrderType == 3 ? item?.SeminarDetail?.EarlyBirdPrice : item.Quantity }}
                </div>
              </td>
              <td style="border: 1px solid; width: 20%" v-if="orderDetails?.Items[0]?.OrderType == 3 && orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !== 0">
                <div class="d-flex justify-center pa-2">
                  {{ orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount }}%
                </div>
              </td>
              <td style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center pa-2">
                  <span v-if="item.OrderType == 5">
                    {{ item.ExamDetail?.PaidAmount }}
                  </span>
                  <span v-else-if="item.OrderType == 3">
                    <span v-if="orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !==0">
                      {{ orderDetails?.Items[0]?.SeminarDetail?.FullPrice - ((orderDetails?.Items[0]?.SeminarDetail?.FullPrice * orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100) }}
                    </span>
                    <span v-else>
                      <span v-if="isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime)">
                        {{ orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice }}
                      </span>
                      <span v-else>
                        {{ orderDetails?.Items[0]?.SeminarDetail?.FullPrice }}
                      </span>
                    </span>
                  </span>
                  <span v-else-if="item.OrderType == 1">
                    {{ (membershipPrice) }}
                  </span>
                  <span v-else>
                    <span v-if="item?.Product?.CategoryId === 26">
                      {{ item?.Payment?.Price?.toFixed(2) }}
                    </span>
                    <span v-else>
                      {{
                        (item?.Amount * item?.Quantity)?.toFixed(2)
                      }}
                      <!-- {{
                        (
                          item.Product?.PublicPrice *
                          item.Quantity *
                          (1 - item.Product?.DiscountPercentage / 100)
                        ).toFixed(2)
                      }} -->
                    </span>
                  </span>
                </div>
              </td>
            </tr>
          </table>
          <!-- <div style="width: 100%" class="d-flex align-center">
            <div style="width: 80.2%; border: 1px solid; border-top: none">
              <div class="pa-2 px-4"><b>Shipment Charges</b></div>
            </div>
            <div
              style="
                width: 20%;
                border: 1px solid;
                border-top: none;
                border-left: none;
              "
            >
              <div class="d-flex justify-center pa-2">
                $ {{ (shippingPrice)?.toFixed(2) }}
              </div>
            </div>
          </div> -->
          <div style="width: 100%" class="d-flex align-center">
            <div style="width: 80.2%; border: 1px solid; border-top: none">
              <div class="pa-2 px-4"><b>Product Total</b></div>
            </div>
            <div
              style="
                width: 20%;
                border: 1px solid;
                border-top: none;
                border-left: none;
              "
            >
              <div class="d-flex justify-center pa-2">
                <span v-if="orderDetails?.Items[0]?.OrderType == 5">$ {{ orderDetails?.Items[0]?.ExamDetail?.PaidAmount }}</span>
                <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
                  <span v-if="orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !==0">
                    {{ orderDetails?.Items[0]?.SeminarDetail?.FullPrice - ((orderDetails?.Items[0]?.SeminarDetail?.FullPrice * orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100) }}
                  </span>
                  <span v-else>
                    <span v-if="isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime)">
                      {{ orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice }}
                    </span>
                    <span v-else>
                      {{ orderDetails?.Items[0]?.SeminarDetail?.FullPrice }}
                    </span>
                  </span>
                </span>
                <span v-else-if="orderDetails?.Items[0]?.OrderType == 1">
                  $ {{ (membershipPrice) }}
                </span>
                <span v-else>
                  $ <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                    {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
                  </span>
                  <span v-else>
                    {{
                      calculateTotalDiscount(orderDetails && orderDetails?.Items)
                        .totalAmount
                    }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider></v-divider>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Payment Method:</span>
      </v-col>

      <v-col cols="12" md="9">
        <div>
          <div class="d-flex algin-center">
            <div v-if="orderDetails?.Items[0]?.PaymentType == 1">
              <VisaSvgIcon class="mr-3"></VisaSvgIcon>
              <div class="d-flex align-center">
                <!-- <div class="mt-2">****</div> -->
                <div v-if="orderDetails?.Items[0]?.OrderType == 1">
                  {{
                    orderDetails?.Items[0]?.MemberShipDetail?.CardNumber &&
                    "**** " + orderDetails?.Items[0]?.MemberShipDetail?.CardNumber.slice(-4)
                  }}
                </div>
                <div v-else>
                  {{
                    orderDetails?.Items[0]?.Payment?.CardNumber &&
                    "**** " + orderDetails?.Items[0]?.Payment?.CardNumber.slice(-4)
                  }}
                </div>
              </div>
            </div>
            <span v-else-if="orderDetails?.Items[0]?.PaymentType == 2">Paypal</span>
            <span v-else-if="orderDetails?.Items[0]?.PaymentType == 3">Admin</span>
          </div>
          <!---------------------if payemnt on Paypal ------------------------------------>
          <!-- <span> Paypal</span> -->
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Product Total:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >
            <span v-if="orderDetails?.Items[0]?.OrderType == 5">
              $ {{ (orderDetails?.Items[0]?.ExamDetail?.PaidAmount)?.toFixed(2) }}
            </span>
            <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
              <span v-if="orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !==0">
                $ {{ (orderDetails?.Items[0]?.SeminarDetail?.FullPrice - ((orderDetails?.Items[0]?.SeminarDetail?.FullPrice * orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100))?.toFixed(2) }}
              </span>
              <span v-else>
                <span v-if="isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime)">
                  $ {{ (orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice)?.toFixed(2) }}
                </span>
                <span v-else>
                  $ {{ (orderDetails?.Items[0]?.SeminarDetail?.FullPrice)?.toFixed(2) }}
                </span>
              </span>
            </span>
            <span v-else-if="orderDetails?.Items[0]?.OrderType == 1">
              $ {{ (membershipPrice)?.toFixed(2) }}
            </span>
            <span v-else>
              $
              <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
              </span><span v-else>{{
                calculateTotalDiscount(orderDetails && orderDetails?.Items)
                  .totalAmount
              }}</span>
            </span>
          </span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0].OrderType == 1 && (orderDetails?.Items[0]?.MemberShipDetail?.MembershipID == 5 || orderDetails?.Items[0]?.MemberShipDetail?.MembershipID == 10)">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">License Fee:</span>
      </v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2">$ {{(instructorLevelFee).toFixed(2)}}</span>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0].OrderType == 1 && (orderDetails?.Items[0]?.MemberShipDetail?.MembershipID == 5 || orderDetails?.Items[0]?.MemberShipDetail?.MembershipID == 10)">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Total Credits Earned:</span>
      </v-col>
      <v-col cols="12" md="9">
        <!-- <span class="style_txt_hh2">$ {{(orderDetails?.Items[0]?.InstructorPreviousRecord ? orderDetails?.Items[0]?.InstructorPreviousRecord?.CreditsEarned : 0).toFixed(2)}}</span> -->
        <span class="style_txt_hh2">$ {{(orderDetails?.Items[0]?.MemberShipDetail?.TotalCreditsEarned || 0)?.toFixed(2)}}</span>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.OrderType == 2">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Product Discount:</span>
      </v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2">$ {{ calculateTotalDiscount(orderDetails && orderDetails?.Items)
          .totalDiscountApplied }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.OrderType == 2">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Coupon Discount:</span>
      </v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2">$ {{ calculateTotalDiscount(orderDetails && orderDetails?.Items)
          .couponDiscount }}</span>
      </v-col>
    </v-row>
    <v-row v-if="orderDetails?.Items[0]?.OrderType == 1 && (orderDetails?.Items[0]?.MemberShipDetail?.MemberLocation == 'Brazil' || orderDetails?.Items[0]?.MemberShipDetail?.MemberLocation == 'Japan')" class="mt-0">
      <v-col cols="12" md="3"><span class="style_txt_hh1">{{ orderDetails?.Items[0]?.MemberShipDetail?.MemberLocation }} Discount:</span></v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2">
          <span>
            $ {{ (orderDetails?.Items[0]?.MemberShipDetail?.LocationDiscount)?.toFixed(2) }}
          </span>
        </span>
      </v-col>
    </v-row>
    
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Total Discount</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >
            <span v-if="orderDetails?.Items[0]?.OrderType == 5">
              $ <span v-if="orderDetails?.Items[0]?.Coupon">{{orderDetails?.Items[0]?.Coupon}}</span><span v-else>0.00</span>
            </span>
            <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
              $ <span v-if="orderDetails?.Items[0]?.CouponDetail">
                {{ (orderDetails?.Items[0]?.Amount * (parseFloat(orderDetails?.Items[0]?.CouponDetail?.DiscountValue) / 100))?.toFixed(2) }}
              </span><span v-else>0.00</span>
            </span>
            <span v-else-if="orderDetails?.Items[0]?.OrderType == 1">
              $ <span>
                {{(totalDiscountWithMembershipLocation)?.toFixed(2)}}
              </span>
            </span>
            <span v-else>
              $ {{ totalDiscountvalue }}
              <!-- {{((calculateTotalDiscount(orderDetails && orderDetails?.Items)
                .totalAmount) * (parseFloat(orderDetails?.Items[0]?.CouponDetail?.DiscountValue) /100)).toFixed(2)}} -->
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="orderDetails?.Items[0]?.OrderType == 1" class="mt-0">
      <v-col cols="12" md="3"><span class="style_txt_hh1">Prorated Adjustment:</span></v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2">
          <span>
            $ {{ (orderDetails?.Items[0]?.MemberShipDetail?.ProratedAdjustment)?.toFixed(2) }}
          </span>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Subtotal:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            <span v-if="orderDetails?.Items[0]?.OrderType == 5">
              $ {{ orderDetails?.Items[0]?.ExamDetail?.PaidAmount }}
            </span>
            
            <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
              <span v-if="orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !==0">
                $ {{ (orderDetails?.Items[0]?.SeminarDetail?.FullPrice - ((orderDetails?.Items[0]?.SeminarDetail?.FullPrice * orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100))?.toFixed(2) }}
              </span>
              <span v-else>
                $ {{ ((isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime) ? orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice : orderDetails?.Items[0]?.SeminarDetail?.FullPrice) - (orderDetails?.Items[0]?.Amount * ((parseFloat(orderDetails?.Items[0]?.CouponDetail?.DiscountValue) / 100) || 0)))?.toFixed(2) }}
              </span>
            </span>

            <span v-else-if="orderDetails?.Items[0]?.OrderType == 1">
              $ 
              {{(((membershipPrice) - (orderDetails?.Items[0]?.MemberShipDetail?.ProratedAdjustment) - totalDiscountWithMembershipLocation) + Number(instructorLevelFee) - Number(orderDetails?.Items[0]?.MemberShipDetail?.TotalCreditsEarned ? orderDetails?.Items[0]?.MemberShipDetail?.TotalCreditsEarned : 0))?.toFixed(2)}}
            </span>

            <span v-else>
              $
              <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
              </span><span v-else>{{
                (calculateTotalDiscount(orderDetails && orderDetails?.Items)
              .totalAmountWithDiscount - calculateTotalDiscount(orderDetails && orderDetails?.Items)
              .couponDiscount)?.toFixed(2)
              }}</span>
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Tax:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$ {{ calculateTax?.toFixed(2) }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$ {{ (shippingPrice)?.toFixed(2) }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0 mb-16">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"><b>Total:</b></span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            ><b>
              <span v-if="orderDetails?.Items[0]?.OrderType == 5">
                $ {{ (orderDetails?.Items[0]?.ExamDetail?.PaidAmount)?.toFixed(2) }}
              </span>
              <span v-else-if="orderDetails?.Items[0]?.OrderType == 3">
                <span v-if="orderDetails?.Items[0]?.SeminarDetail?.MonitorRate && orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount !==0">
                  $ {{ (orderDetails?.Items[0]?.SeminarDetail?.FullPrice - ((orderDetails?.Items[0]?.SeminarDetail?.FullPrice * orderDetails?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100))?.toFixed(2) }}
                </span>
                <span v-else>
                  $ {{ ((isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime) ? orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice : orderDetails?.Items[0]?.SeminarDetail?.FullPrice) - (orderDetails?.Items[0]?.CouponDetail ? ((isDateEqualOrGreater(orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdEndTime) ? orderDetails?.Items[0]?.SeminarDetail?.EarlyBirdPrice : orderDetails?.Items[0]?.SeminarDetail?.FullPrice) * ((parseFloat(orderDetails?.Items[0]?.CouponDetail?.DiscountValue) / 100))) : 0))?.toFixed(2) }}
                </span>
              </span>
              <span v-else-if="orderDetails?.Items[0]?.OrderType == 1">
                $ 
                {{(((membershipPrice) - (orderDetails?.Items[0]?.MemberShipDetail?.ProratedAdjustment) - totalDiscountWithMembershipLocation) + Number(instructorLevelFee) - Number(orderDetails?.Items[0]?.MemberShipDetail?.TotalCreditsEarned ? orderDetails?.Items[0]?.MemberShipDetail?.TotalCreditsEarned : 0))?.toFixed(2)}}
              </span>
              <span v-else>
                $
                <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                  {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
                </span><span v-else>
                    {{ (Number(calculateTotalDiscount(orderDetails && orderDetails?.Items)
                      .totalAmountWithDiscount) + shippingPrice + calculateTax - calculateTotalDiscount(orderDetails && orderDetails?.Items)
                      .couponDiscount)?.toFixed(2) }}
              </span>
              </span></b></span
          >
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">User Credits</span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">($25.00)</span></div>
      </v-col>
    </v-row> -->

    <!-- <v-col cols="12" md="3">
      <span class="style_txt_hh1">Total Discounts</span>
    </v-col>
    <v-col cols="12" md="9">
      <div>
        <span class="style_txt_hh2"
          >(${{
            calculateTotalDiscount(orderDetails && orderDetails.Items)
          }})</span
        >
      </div>
    </v-col> -->

    <!-- $ {{ orderDetails && orderDetails.Items[0].Payment.Price }} -->
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Tax:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">$0.00</span></div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping </span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">$0.00</span></div>
      </v-col>
    </v-row> -->

    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span><b></b></span>
      </v-col>
      <v-col cols="12" md="9">
       
    <div class="mt-10">
    <v-btn depressed color="primary">
        Update
    </v-btn>
    </div>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import VisaSvgIcon from "../../assets/SvgIcons/VisaSvgIcon.vue";

export default {
  name: "my-component",
  props: {
    shipmethod: {
      type: String,
      default: "cash on delivery",
    },
  },
  components: { VisaSvgIcon },
  data() {
    return {
      isRecieveOrShipDate: false,
      IsEditing: false,
      time: "5:54 a.m",
      select: { state: "VOID" },
      orderStatusItems: [
        { state: "NEW", Status: 2 },
        { state: "RECEIVED", Status: 3 },
        { state: "SHIPPED", Status: 4 },
        { state: "INVOICED", Status: 5 },
        { state: "VOID", Status: 6 },
      ],
      orderDetails: null,
      selectedStatus: 2,
      notes: "",
      tax: 0
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions", "GetSales", "GetUsers", "GetProductCategories"]),
    orderDetailsStatus() {
      return this.orderDetails && this.orderDetails?.Items[0]?.Status;
    },
    getExamCredentialsLabel() {
    return (examCredentialsLabel) => {
      switch (examCredentialsLabel) {
        case 1:
          return "CBP";
        case 2:
          return "CBP-A";
        case 3:
          return "AdvCBP 4(7) & 9";
        case 4:
          return "AdvCBP 3 & 6";
        case 5:
          return "PaRama";
        case 6:
          return "Adv_CBP";
          // return "Adv_CBP479";
        case 7:
          return "Adv_CBP";
          // return "Adv_CBP36";
        default:
          return "";
      }
    };
  },
  getProductCategoryLabel() {
  return (categoryId) => {
    const category = this.GetProductCategories.find(
      (item) => item.Category.Id === categoryId
    );
    return category ? category.Category.CategoryName : "";
  };
},
    shippingPrice() {
      let str = this.orderDetails?.Items[0]?.Shipping?.ShippingMethod;
      let match = str?.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number
      }
      return 0
    },
    totalDiscountWithMembershipLocation(){
      const coupon = this.orderDetails?.Items[0]?.CouponDetail ? (this.orderDetails?.Items[0]?.CouponDetail?.DiscountType == 1 ? ((this.membershipPrice) * (parseFloat(this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue) /100)) : this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue) : 0
      const LocationDiscount = this.orderDetails?.Items[0]?.MemberShipDetail?.MemberLocation == 'Brazil' || this.orderDetails?.Items[0]?.MemberShipDetail?.MemberLocation == 'Japan' ? this.orderDetails?.Items[0]?.MemberShipDetail?.LocationDiscount : 0
      // const totalDiscountwithLocationDiscount = coupon + LocationDiscount
      return coupon + LocationDiscount;
    },
    totalDiscountvalue() {
      const discountApplied = parseFloat(this.calculateTotalDiscount(this.orderDetails && this.orderDetails?.Items).totalDiscountApplied) || 0;
      const couponDiscount = parseFloat(this.calculateTotalDiscount(this.orderDetails && this.orderDetails?.Items).couponDiscount) || 0;

      const totaldiscountvalue = discountApplied + couponDiscount;
      return totaldiscountvalue?.toFixed(2);
    },
    instructorLevelFee() {
      // const instructorFee = this.orderDetails?.Items[0]?.InstructorPreviousRecord?.InstructorLevel == 1 ? 100 : this.orderDetails?.Items[0]?.InstructorPreviousRecord?.InstructorLevel == 2 ? 200 : this.orderDetails?.Items[0]?.InstructorPreviousRecord?.InstructorLevel == 3 ? 450 : 0;
      const instructorFee = this.orderDetails?.Items[0]?.MemberShipDetail?.LicensingFee;
      return instructorFee ? Number(instructorFee) : 0;
    },
    membershipPrice(){
      const price = this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 1 ? 0 : this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 2 ? 40 : this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 3 ? 150 : this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 4 ? 300 : this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 5 ? 300 : this.orderDetails?.Items[0]?.MemberShipDetail?.MembershipID === 10 ? 300 : 0;
      return price;
    },
    calculateTax() {
      if (
        this.orderDetails &&
        this.orderDetails?.Items[0]?.Shipping?.Country?.toLowerCase() === "united states" &&
        this.orderDetails?.Items[0]?.Shipping?.Province?.toLowerCase() === "fl"
      ) {
        const totalAmountWithDiscount = this.calculateTotalDiscount(this.orderDetails?.Items).totalAmountWithDiscount;

        const hasPhysicalProduct = this.orderDetails?.Items?.some((item) => item?.Product?.IsPhysical);

        if (hasPhysicalProduct) {
          return totalAmountWithDiscount * 0.07;
        }
      }
      return 0;
    },
  },
  watch: {
    orderDetailsStatus: {
      immediate: true,
      handler(newValue) {
        if (
          Array.isArray(this.orderStatusItems) &&
          this.orderStatusItems?.length > 0
        ) {
          this.selectedStatus = newValue;
        }
      },
    },
  },

  mounted() {
    this.fetchData(this.isRecieveOrShipDate);
    if(this.GetProductCategories?.length == 0){
      this.$store.dispatch("GetProductCategories");
    }
  },
  methods: {
    extractMonthAndDate(dateTimeString) {
      const date = new Date(dateTimeString);
      const month = date.toLocaleString("en-US", { month: "short" });
      const day = date.getDate();
      return `${day} ${month}`;
    },
    isDateEqualOrGreater(inputDateStr) {
      const inputDate = new Date(inputDateStr);
      const currentDate = new Date();

      // Check if the input date is today or a future date
      if (inputDate.getFullYear() > currentDate.getFullYear()) {
        return true;
      } else if (inputDate.getFullYear() === currentDate.getFullYear()) {
        if (inputDate.getMonth() > currentDate.getMonth()) {
          return true;
        } else if (inputDate.getMonth() === currentDate.getMonth()) {
          if (inputDate.getDate() >= currentDate.getDate()) {
            return true;
          }
        }
      }
      return false;
    },
    fetchData(istrue){
      this.orderDetails = this.GetSales?.list?.find(
      (order) => order.OrderCode === this.$route.query.ordernumber
    );

    if (!this.orderDetails || istrue) {
      this.$store
        .dispatch("GetAllOrder",{ pageNumber: -1 })
        // .then(() => this.$store.dispatch("GetSales"))
        .then(() => {
          this.orderDetails = this.GetSales.list.find(
            (order) => order.OrderCode === this.$route.query.ordernumber
          );
          // let price = this.calculateTotalDiscount(this.orderDetails && this.orderDetails?.Items)
          // .totalAmountWithDiscount
          // this.tax = price * 0.07

          if (!this.orderDetails) {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "No Data Found",
              showConfirmButton: false,
              timer: 3500,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching orders:", error);
        });
    }
    },
    Update(editNote,Id){
      // const obj = {
      //   ShippingId:Id,
      //   ShippingNote:editNote
      // }
      // this.$store.dispatch("EditShippingDetails",obj).then(()=>{
      //   this.IsEditing = false
      //   this.$swal.fire({
      //       toast: true,
      //       position: "top-end",
      //       icon: "success",
      //       title: "ShippingNote Update Successfully",
      //       showConfirmButton: false,
      //       timer: 2500,
      //     });
      // })
      const obj = {
        OrderCode:Id,
        Note:editNote
      }
      this.$store.dispatch("EditOrderAdminNote",obj).then(()=>{
        this.IsEditing = false
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Admin note updated successfully",
            showConfirmButton: false,
            timer: 2500,
          });
      })
    },
    formatDate(dateString) {
      if (!dateString) {
        return;
      }
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };

      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", options);
    },
    async setNewOrderStatus() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      let hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const formattedDateTime = `${formattedDate}T${hours}:${minutes}:${seconds}`;

      const selectedStatusObject = this.selectedStatus;
      const selectedStatusValue = selectedStatusObject
        ? selectedStatusObject.Status
        : null;

      var obj = {
        orderCode: this.$route.query.ordernumber,
        status: selectedStatusValue,
      };

      var data = {
        id: this.orderDetails?.Items[0]?.Shipping?.Id,
        status: selectedStatusValue,
        dateTime: formattedDateTime,
      };

      if (selectedStatusValue == 3 || selectedStatusValue == 4) {
        if(!this.orderDetails?.Items[0]?.Shipping?.Id) {
          await this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "info",
            title: `The ${selectedStatusValue == 3 ? 'recieved' : 'shipped'} date will not be showing because shipping id is not found`,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }

      await this.$store
        .dispatch("ChangeOrderStatus", obj)
        .then((res) => {
          if (res.Status) {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Status changed successfully",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          console.error("Error changing order status:", error);
          // this.$store.dispatch("GetAllOrder");
        });

        if (selectedStatusValue == 3 || selectedStatusValue == 4) {
          if(!this.orderDetails?.Items[0]?.Shipping?.Id) {
            return;
          }
        this.$store
          .dispatch("UpdateOrderShipAndReceivedDate", data)
          .then(() => {
            this.fetchData(true);
          });
      }
    },
    
    calculateTotalDiscount(items) {
      if (Array.isArray(items) && items?.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue
          ? totalAmount * (parseFloat(this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue) / 100)
          : 0;

        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },

    calculateAmountAndDiscount(item) {
      // Calculate the discounted amount for a single item
      const discountedAmount = (
        (1 - item.Product?.DiscountPercentage / 100) * // Discount factor
        item.Amount *
        item.Quantity
      )?.toFixed(2);

      // Calculate the total amount for a single item
      const amount = (item.Amount * item.Quantity)?.toFixed(2);

      // Return an object containing both the total amount and discounted amount
      return { amount, discountedAmount };
    },
  },
};
</script>

<style scoped>
.sub-heading {
  font-size: 20px;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: rgba(34, 34, 34, 0.7);
}
.style_txt_hh2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: inline-block;
  color: #222222;
}
.stying_text {
  text-transform: none !important;
  border: 1px solid #d2e5fc;
  font-size: 14px;
  font-family: "DM Sans";
}
.text_trans {
  text-transform: none;
}
</style>
